import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import sharedFoldersImage from 'img/family-content/empty-new-block-family-folders.png';
import sharedFoldersImageDark from 'img/family-content/empty-new-block-family-folders-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import baseStyles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

import styles from './FamilyContentNewEmptyCards.css';

export const SharedFolders = (): ReactElement => {
    const onClick = (): void => {
        xray.send('empty_family-folder_create', { p: 'cloud' });
        toolbarActions.create('familyFolder', 'emptyState', undefined, '', true, true);
    };

    return (
        <div id="family-card-folders" className={`${baseStyles.card}`} onClick={onClick} data-qa-id="family-shared-folders">
            <Title level="2" data-qa-id="family-shared-folders-title">
                Создайте&nbsp;семейную&nbsp;папку
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-folders-content">
                Она будет общей для всех в семейной
                <br />
                подписке
            </Text>
            <Spacing size={20} style={{ pointerEvents: 'none' }} />
            <Button
                mode="primary"
                appearance="accent-invariable"
                size="l"
                className={styles.button}
                data-qa-id="family-shared-folders-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                Создать папку
            </Button>
            <img
                src={isDarkTheme ? sharedFoldersImageDark : sharedFoldersImage}
                alt="Общие папки"
                className={styles.image}
                data-qa-id="family-shared-folders-image"
            />
        </div>
    );
};
